import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

require("priority-plus");

import dragScroll from "dragscroll/dragscroll";
window.dragScroll = dragScroll;

import flatpickr from "flatpickr";
window.flatpickr = flatpickr;

import tinymce from "tinymce/tinymce";
window.tinymce = tinymce;
// Default icons are required. After that, import custom icons if applicable
import 'tinymce/icons/default';

// Required TinyMCE components
import 'tinymce/themes/silver';
import 'tinymce/models/dom';

// TinyMCE plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/link';
import 'tinymce/plugins/code';

//import Swiper from "swiper";
//window.Swiper = Swiper;

let Swiper = require('swiper/swiper-bundle.js');
window.Swiper = Swiper;


